// extracted by mini-css-extract-plugin
export default {"small_italic_text":"UN","wrapper":"VN","page":"WN","topblock":"XN","nextBtn":"YN","bottomnav":"ZN","MyClassEnterDone":"aO","topname":"bO","text":"cO"};
    if(module.hot) {
      // 1715188237895
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  